import magicWandIcon from './magic-wand.svg';
import trophyIcon from './trophy.svg';
import feedbackImage from './feedback.png';
import { Box, Text, IconButton, Divider, Button, Flex, Spinner } from '@chakra-ui/react';

import { HStack, VStack } from "@chakra-ui/react";
import { KeyboardArrowLeft, KeyboardArrowRight, ScheduleOutlined, TrendingDown, TrendingUp } from '@mui/icons-material';
import apiClient from '../../clients/apiClient.js';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const EmptyScreen = ({ setInputValue }) => {
    const [homeData, setHomeData] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(true);
    React.useEffect(() => {
        apiClient.get('/serve-homepage').then(({ data }) => {
            setHomeData(data);
            setIsLoading(false);
        })
    }, []);
    
    if (isLoading) {
        return (
            <Flex width={'100%'} height="72vh" justifyContent={'center'} alignItems={"center"} py={20}>
              <Spinner
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.200"
                color="blue.500"
                size="lg"
              />
            </Flex>
        )
    }
    return (
        <Box paddingLeft={"24px"} backgroundColor={"#F6FAFF"} width={"100%"} maxW={"100%"}
            height={"100%"}
            maxH={"100%"}
        >
            <Box
                borderTopLeftRadius={"24px"}
                borderBottomLeftRadius={"24px"}
                backgroundColor={"white"}
                width={"100%"}
                maxW={"100%"}
                height={"100%"}
                maxH={"100%"}
                paddingTop={"25px"}
                paddingLeft={"24px"}
                paddingRight={"8px"}
            >
                <VStack align={"start"} flex={4} gap={0} maxWidth={"100%"}
                    height={"100%"}
                    maxH={"100%"}
                    overflowY={"scroll"}
                    data-scrollable="true"
                >
                    <Box h={"32px"}>
                        <Text fontFamily={"sans-serif"} color={"#000000"} fontSize={"24px"} fontWeight={"600"}>
                            Welcome {homeData?.profile?.first_name || "Proposal Manager" }, What's on your List today? 👋
                        </Text>
                    </Box>
                    {
                        homeData ? <GetActiveTasksV2 homeData={homeData} /> : null
                    }
                    <Overview isDemoApp={homeData?.is_demo_app}/>
                    <Feedback />
                    <WhiteSpace />
                </VStack>
            </Box>
        </Box>
  );
}

const GetActiveTasksV2 = ({homeData}) => {
    const showNoTasks = () => {
        if (homeData?.active_tasks == null) {
            return true
        }
        if (homeData?.active_tasks?.length == 0) {
            return true
        }

        return false
    }
    return (
        <Box
            marginTop={"24px"}
            borderRadius={"8px"}
            border={"1px solid #F4F4F4"}
            w={"100%"}
            // boxshadow={"0px 4px 6px rgba(0, 0, 0, 0.08)"}
            _hover={{
                // boxshadow: "0px 4px 6px rgba(0, 0, 0, 0.12)",
                // borderColor: "#D4D4D4",
            }}
            paddingY={"16px"}
            paddingX={"24px"}
        >
            <Box
                height={"28px"}
                fontSize={"18px"}
                fontWeight={"semibold"}
                fontColor={"#1D1D1D"}
            >
                Active Tasks
            </Box>
            <HStack 
                // marginTop={"19px"} 
                overflowX={"scroll"} 
                // overflowY={"hidden"} 
                data-scrollable="true" 
                // gap={"12px"} 
                maxWidth={"100%"} 
                h={showNoTasks() ? "36px" : "172px"}
                // minH={"195px"}
                marginY={0}
                padding={0}
                marginTop={"16px"}
                gap={"24px"}
            >
                {
                    showNoTasks() ? (
                        <Text 
                            lineHeight={"24px"}
                            fontSize={"14px"}
                            fontWeight={"400"}
                            fontColor={"#3d3d3d"}
                        >
                            No active tasks yet - let's get started on your first one. We're rooting for your first win with Thalamus AI
                        </Text>
                    ) : (
                        homeData?.active_tasks?.map((task, index) => (
                            <ActiveTaskCard 
                                key={index}
                                heading={task.name}
                                body={task.status_message}
                                tag={task.type}
                                percentage={task.percentage_complete}
                                taskId={task.id}
                            />
                        ))
                    )
                }
            </HStack>
        </Box>
    )
}

const ActiveTaskCard = ({key, heading, body, tag, percentage, taskId}) => {
    const navigate = useNavigate();
    return (
        <VStack
            key={key}
            align={"start"} 
            bgColor={"#FAFAFF"} 
            // paddingY={"24px"} 
            // paddingX={"16px"} 
            padding={"16px"}
            gap={"8px"} 
            minWidth={"328px"}
            maxWidth={"328px"}
            border={"1px solid #F4F4F4"}
            borderRadius={"8px"}
            _hover={{ 
                cursor: "pointer",
                backgroundColor: "#F2F2F7",
                // boxshadow: "0px 4px 8px rgba(0, 0, 0, 0.14)",
            }} 
            m={0}
            // boxshadow={"0px 4px 6px rgba(0, 0, 0, 0.08)"}
            onClick={()=> {navigate(`/t/${taskId}`)}}
        >
            <HStack width={"100%"} justifyContent={"space-between"}>
                <Text height={"24px"} fontFamily={"sans-serif"} color={"#1D1D1D"} fontSize={"14px"} fontWeight={"600"} isTruncated>
                    {heading}
                </Text>
                <Box
                    border={"1px"}
                    borderColor={"#E5E5E5"}
                    borderRadius={"4px"}
                    background={"#E3E6EA"}
                    paddingX={"4px"}
                >
                    {tag}
                </Box>
            </HStack>
            <Text fontFamily={"sans-serif"} color={"#1D1D1D"} fontSize={"14px"} fontWeight={"400"} h={"42px"} noOfLines={2}>
                {body}
            </Text>
            <Box
                width={"100%"}
                height={"4px"}
                borderRadius={"4px"}
                backgroundColor={"#E5E5E5"}
            >
                <Box
                    width={`${Math.min(percentage, 100)}%`}
                    height={"100%"}
                    borderRadius={"4px"}
                    backgroundColor={"#2584FD"}
                />
            </Box>
            <Text fontFamily={"sans-serif"} color={"#1D1D1D"} fontSize={"14px"} fontWeight={"400"} lineHeight={"18px"}>
                {percentage}% completed
            </Text>
        </VStack>
    )
  }

const Overview = ({isDemoApp}) => {
    return (
        <Box
            paddingY={"16px"}
            paddingX={"24px"}
            border={"1px solid #F4F4F4"}
            borderRadius={"8px"}
            marginTop={"24px"}
            width={"100%"}
            _hover={{
                // boxshadow: "0px 4px 8px rgba(0, 0, 0, 0.12)",
            }}
            // boxshadow={"0px 4px 6px rgba(0, 0, 0, 0.08)"}
        >
            <VStack
                align={"start"} 
                gap={0}
                width={"100%"}
            >
                <Text lineHeight={"28px"} fontSize={"18px"} fontColor={"#1d1d1d"} fontWeight={"semibold"}>
                    Overview
                </Text>
                <VStack
                    marginTop={"14px"}
                    height={"147px"}
                    padding={"16px"}
                    paddingX={"26px"}
                    w={"100%"}
                    background={`linear-gradient(90deg, #E7F1FC 0%, #E0D7E6 100%)`}
                    borderRadius={"8px"}
                    align={"start"}
                    gap={0}
                >
                    {isDemoApp ? (
                        <>
                            <HStack gap={"4px"}>
                                <Text lineHeight={"24px"} fontSize={"16px"} color={"#1d1d1d"} fontWeight={"600"} marginTop={"5px"}>
                                    Agentic Insights are currently 
                                </Text>
                                <Text lineHeight={"24px"} fontSize={"16px"} color={"#2584FD"} fontWeight={"600"} marginTop={"5px"}>
                                    unavailable for your organization.
                                </Text>
                            </HStack>
                            <VStack
                                align={"start"} 
                                gap={0}
                                width={"100%"}
                                marginTop={"4px"}
                            >
                                <Text
                                    fontSize={"14px"}
                                    fontColor={"#3D3D3D"}
                                    fontWeight={"regular"}
                                    lineHeight={"24px"}
                                >
                                    Contact your account manager to unlock actionable intelligence that enhances response workflows and drives measurable efficiency gains.
                                </Text>
                                <Text
                                    fontSize={"14px"}
                                    fontColor={"#3D3D3D"}
                                    fontWeight={"regular"}
                                    lineHeight={"24px"}
                                    h={"24px"}
                                >
                                </Text>
                            </VStack>
                            <HStack
                                marginTop={"11px"}
                                height={"24px"}
                                display={"flex"}
                                justifyContent={"center"}
                                alignItems={"center"}
                                width={"100%"}
                            >
                                <IconButton
                                    sx={{
                                        height: '24px',
                                        width: '24px',
                                        padding: 0,
                                        fontSize: 24,
                                        color: '#5d5d5d',
                                        backgroundColor: 'transparent',
                                        '&:hover': {
                                            backgroundColor: 'transparent',
                                        },
                                        minW: "24px",
                                    }}
                                >
                                    <KeyboardArrowLeft
                                        sx={{
                                            padding: 0,
                                            fontSize: 24,
                                            color: '#ADADAD',
                                            bgcolor: 'transparent',
                                        }}
                                    />
                                </IconButton>
                                <Text>
                                    1 of 1
                                </Text>
                                <IconButton
                                    sx={{
                                        height: '24px',
                                        width: '24px',
                                        padding: 0,
                                        fontSize: 24,
                                        color: '#5d5d5d',
                                        backgroundColor: 'transparent',
                                        '&:hover': {
                                            backgroundColor: 'transparent',
                                        },
                                        minW: "24px",
                                    }}
                                >
                                    <KeyboardArrowRight
                                        sx={{
                                            padding: 0,
                                            fontSize: 24,
                                            color: '#ADADAD',
                                            bgcolor: 'transparent',
                                        }}
                                    />
                                </IconButton>
                            </HStack>
                        </>
                    ): (
                    <>
                        <HStack gap={"4px"}>
                            <Text lineHeight={"24px"} fontSize={"16px"} color={"#1d1d1d"} fontWeight={"600"} marginTop={"5px"}>
                                Early stakeholder engagement drives
                            </Text>
                            <Text lineHeight={"24px"} fontSize={"16px"} color={"#2584FD"} fontWeight={"600"} marginTop={"5px"}>
                                28% faster RFP finalization
                            </Text>
                            {/* <IconButton
                                sx={{
                                    height: '24px',
                                    width: '24px',
                                    padding: 0,
                                    fontSize: 20,
                                    color: '#5d5d5d',
                                    bgcolor: 'transparent',
                                    '&:hover': {
                                        backgroundColor: 'transparent',
                                    },
                                    minW: "24px",
                                }}
                            >
                                <TrendingUp
                                    sx={{
                                        padding: 0,
                                        fontSize: 20,
                                        color: '#009652',
                                        bgcolor: 'transparent',
                                    }}
                                />
                            </IconButton> */}
                        </HStack>
                        <VStack
                            align={"start"} 
                            gap={0}
                            width={"100%"}
                            marginTop={"4px"}
                        >
                            <Text
                                fontSize={"14px"}
                                fontColor={"#3D3D3D"}
                                fontWeight={"regular"}
                                lineHeight={"24px"}
                            >
                                Engaging SMEs within the first 24 hours leads to faster submissions, better coordination, and fewer revision cycles.
                            </Text>
                            <Text
                                fontSize={"14px"}
                                fontColor={"#3D3D3D"}
                                fontWeight={"regular"}
                                lineHeight={"24px"}
                                h={"24px"}
                            >
                                
                            </Text>
                        </VStack>
                        <HStack
                            marginTop={"11px"}
                            height={"24px"}
                            display={"flex"}
                            justifyContent={"center"}
                            alignItems={"center"}
                            width={"100%"}
                        >
                            <IconButton
                                sx={{
                                    height: '24px',
                                    width: '24px',
                                    padding: 0,
                                    fontSize: 24,
                                    color: '#5d5d5d',
                                    backgroundColor: 'transparent',
                                    '&:hover': {
                                        backgroundColor: 'transparent',
                                    },
                                    minW: "24px",
                                }}
                            >
                                <KeyboardArrowLeft
                                    sx={{
                                        padding: 0,
                                        fontSize: 24,
                                        color: '#ADADAD',
                                        bgcolor: 'transparent',
                                    }}
                                />
                            </IconButton>
                            <Text>
                                1 of 2
                            </Text>
                            <IconButton
                                sx={{
                                    height: '24px',
                                    width: '24px',
                                    padding: 0,
                                    fontSize: 24,
                                    color: '#5d5d5d',
                                    backgroundColor: 'transparent',
                                    '&:hover': {
                                        backgroundColor: 'transparent',
                                    },
                                    minW: "24px",
                                }}
                            >
                                <KeyboardArrowRight
                                    sx={{
                                        padding: 0,
                                        fontSize: 24,
                                        color: '#5D5D5D',
                                        bgcolor: 'transparent',
                                    }}
                                />
                            </IconButton>
                        </HStack>
                    </>
                    )}
                </VStack>
                <Divider marginTop={"18px"} marginBottom={"12px"}/>
                <HStack
                    gap={"24px"}
                    marginTop={"14px"}
                    justifyContent={"space-between"}
                    overflowX={"scroll"} 
                    data-scrollable="true" 
                    maxWidth={"100%"}
                    height={"112px"}
                >
                    <StatCard 
                        iconType={"clock"}
                        header={"SME Response time"}
                        primaryText={isDemoApp ? "—" : "3.2 hrs"}
                        secondaryText={isDemoApp ? "" : "12%"}
                        secondaryIconType={isDemoApp ? "" : "down"}
                    />
                    <StatCard 
                        iconType={"magic-wand"}
                        header={"Responses auto-filled by Thalamus AI"}
                        primaryText={isDemoApp ? "—" : "87%"}
                    />
                    <StatCard
                        iconType={"trophy"}
                        header={"RFP Win rate"}
                        primaryText={isDemoApp ? "—" : "53%"}
                    />
                </HStack>
            </VStack>
        </Box>
    )
}

const StatCard = ({
    iconType,
    header,
    primaryText,
    secondaryText,
    secondaryIconType,
}) => {
    const DisplayIconType = () => {
        return (
            <IconButton
                sx={{
                    height: '32px',
                    width: '32px',
                    padding: 0,
                    fontSize: 24,
                    color: '#E4F0FF',
                    bgcolor: 'transparent',
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                    minW: "24px",
                    borderRadius: "32px",
                }}
            >
                {
                    iconType == "clock" ? (
                        <ScheduleOutlined
                            sx={{
                                padding: 0,
                                fontSize: 24,
                                color: '#5D5D5D',
                                bgcolor: 'transparent',
                            }}
                        />
                    ) : iconType == "magic-wand" ? (
                        <img
                            src={magicWandIcon}
                            width={"24px"}
                            height={"24px"}
                        />
                    ) : iconType == "trophy" && (
                        <img
                            src={trophyIcon}
                            width={"24px"}
                            height={"24px"}
                        />
                    )
                }
            </IconButton>
        )
    }

    const DisplaySecondaryIconType = () => {
        return (
            <IconButton
                sx={{
                    height: '24px',
                    width: '24px',
                    padding: 0,
                    fontSize: 24,
                    color: '#F6FAFF',
                    backgroundColor: "transparent",
                    '&:hover': {
                        backgroundColor: '#F2F2F7',
                        cursor: 'default',
                    },
                    minW: "24px",
                }}
            >
                {
                    secondaryIconType == "up" ? (
                        <TrendingUp
                            sx={{
                                padding: 0,
                                fontSize: 24,
                                color: '#009652',
                                bgcolor: 'transparent',
                            }}
                        />
                    ) : secondaryIconType == "down" && (
                        <TrendingDown
                            sx={{
                                padding: 0,
                                fontSize: 24,
                                color: '#C82A22',
                                bgcolor: 'transparent',
                            }}
                        />
                    )
                }
            </IconButton>
        )
    }

    return (
        <HStack
            padding={"16px"}
            backgroundColor={"#F6FAFF"}
            align={"start"}
            borderRadius={"8px"}
            minW={"316px"}
            // boxshadow={"2px 4px 6px rgba(0, 0, 0, 0.08)"}
            _hover={{
                // boxshadow: "2px 4px 8px rgba(0, 0, 0, 0.14)",
                backgroundColor: "#F2F2F7",
            }}
        >
            <DisplayIconType />
            <VStack
                gap={"4px"}
                align={"start"}
            >
                <Text
                    lineHeight={"24px"}
                    fontSize={"14px"}
                    fontColor={"#5d5d5d"}
                    fontWeight={"regular"}
                >
                    {header}
                </Text>
                <HStack>
                    <Text
                        lineHeight={"28px"}
                        fontSize={"24px"}
                        fontColor={"#3d3d3d"}
                        fontWeight={"regular"}
                    >
                        {primaryText}
                    </Text>
                    <Text
                        lineHeight={"28px"}
                        fontSize={"14px"}
                        fontColor={"#5d5d5d"}
                        fontWeight={"regular"}
                    >
                        {secondaryText}
                    </Text>
                    <DisplaySecondaryIconType  />
                </HStack>
            </VStack>
        </HStack>
    )
}

const Feedback = () => {
    return (
        <HStack
            height={"135px"}
            padding={"24px"}
            border={"1px solid #F4F4F4"}
            marginTop={"24px"}
            borderRadius={"8px"}
            width={"1435px"}
            maxW={"100%"}
            // boxshadow={"0px 4px 6px rgba(0, 0, 0, 0.08)"}
            _hover={{
                // boxshadow: "0px 4px 8px rgba(0, 0, 0, 0.12)",
            }}
            justifyContent={"space-between"}
        >
            <HStack gap={0}>
                <img
                    src={feedbackImage}
                    width={"108px"}
                    height={"86px"}
                />
                <VStack
                    paddingY={"16px"}
                    paddingX={"24px"}
                    align={"start"}
                    gap={0}
                >
                    <Text
                        lineHeight={"32px"}
                        fontSize={"18px"}
                        fontWeight={"600"}
                        fontColor={"#1d1d1d"}
                    >
                        Submit your feedback
                    </Text>
                    <Text
                        lineHeight={"24px"}
                        fontSize={"14px"}
                        fontWeight={"400"}
                        fontColor={"#3d3d3d"}
                    >
                        Your feedback matters. This will help us to improve in future and make your overall experience better.
                    </Text>
                </VStack>
            </HStack>
            <Button
                width={"138px"}
                height={"40px"}
                backgroundColor={"#2584FD"}
                color={"white"}
                _hover={{
                    backgroundColor: "#2584FD",
                    color: "white",
                }}
            >
                <Text
                    lineHeight={"24px"}
                    fontSize={"14px"}
                    fontWeight={"600"}
                >
                    Submit feedback
                </Text>
            </Button>
        </HStack>
    )
}

const WhiteSpace = () => {
    return (
        <Box
            height={"0px"}
            width={"100%"}
            borderRadius={"8px"}
            backgroundColor={"transparent"}
            marginTop={"24px"}
        >
        </Box>
    )
}


export default EmptyScreen;
